import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.specificstructureoffpremises.address',
        defaultMessage: 'Address'
    },
    description: {
        id: 'ml.quoteandbind.specificstructureoffpremises.description',
        defaultMessage: 'Description of Property'
    },
    limit: {
        id: 'ml.quoteandbind.specificstructureoffpremises.limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'ml.quoteandbind.specificstructureoffpremises.deductible',
        defaultMessage: 'Deductible'
    },
    action: {
        id: 'ml.quoteandbind.specificstructureoffpremises.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.specificstructureoffpremises.modalTitle',
        defaultMessage: 'Add Specific Structure Off Premises'
    },
    addressLine1: {
        id: 'ml.quoteandbind.specificstructureoffpremises.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.specificstructureoffpremises.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.specificstructureoffpremises.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.specificstructureoffpremises.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.specificstructureoffpremises.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.specificstructureoffpremises.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.specificstructureoffpremises.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.specificstructureoffpremises.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.specificstructureoffpremises.continueBtn',
        defaultMessage: 'Continue'
    },
});
